export const MAX_TEXT_LENGTH = 150;
export const TIME_TO_WAIT_CONTAINER_FLEX_TRANSITION = 300;
